import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Card, Form, Tabs, Tab, Image } from 'react-bootstrap';
import Layout from "../../components/Layout.";
import transaction from "../../actions/transaction";
import auth from "../../actions/auth";
import {ReactComponent as NotifSvg} from './../../assets/icons/svg/notif.svg';
import {ReactComponent as ProfileSvg} from './../../assets/icons/svg/profile.svg';
import {ReactComponent as TransactionSvg} from './../../assets/icons/svg/transaction.svg';
import {ReactComponent as DownloadSvg} from './../../assets/icons/svg/download-doc.svg';
import {ReactComponent as CupSvg} from './../../assets/icons/svg/cup.svg';
import {ReactComponent as FilterSvg} from './../../assets/icons/svg/filter.svg';
import {ReactComponent as CheckSvg} from './../../assets/icons/svg/check.svg';
import dayjs from 'dayjs';
import {currencyConverter} from './../../utils/index';
import ListTransaction from "../../components/ListTransaction";
import ListPartner from "../../components/ListPartner";

export default function PartnerList() {
  const [user, setUser] = useState([]);
  const [tabsActive, setTabsActive] = useState('history');
  const [mitra, setMitra] = useState([]);
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyword] = useState('');

  const navigate = useNavigate();
  const loc = useLocation();
  const head_menu = [
    {path: '/notification', icon: <NotifSvg/>},
    {path: '/profile', icon: <ProfileSvg/>},
  ]
  
  const handleClick = (urls) => {
     navigate(urls);
  };

  useEffect(() => {
   setLoading(true)
   if(loc.pathname.includes('verify')){
      getList('registered', '');
      setTabsActive('registered')
   } else {
      auth.actions.get_users().then((res)=>{
         setUser(res?.data)
         transaction.actions.get_partner_filter(keyword).then((res)=>{
            setMitra(res?.data?.data);
            setLoading(false)
         })
      });
   }
   },[])

  
  const getList = (std, search) => {
   setKeyword(search)
   setLoading(true)
   if(std === 'history'){
      transaction.actions.get_partner_filter(search).then((res)=>{
         setMitra(res?.data?.data);
         setLoading(false)
      })
   }
   if(std === 'verified'){
      transaction.actions.get_partner_verified('success', 0, search).then((res)=>{
         setMitra(res?.data?.data);
         setLoading(false)
      })
   }
   if(std === 'registered'){
      transaction.actions.get_partner_verified('success', 1, search).then((res)=>{
         setMitra(res?.data?.data);
         setLoading(false)
      })
   }
  }

  return (
   <Layout active={2}>
      <div className="bg-radial-green-short p-4">
        <Row className="align-items-center">
          <Col xs={8}>
            <div className="d-flex align-items-center">
              <div className="text-smooth ts-sm">Lokasi Kamu</div>
              <i className="ph-caret-down ms-2 text-light"></i>
            </div>
            <div className={"text-light " + (loading ? "skeleton":"")}>
              {loading ? '' : <>{user?.address ? user?.address + ', ' : null} {user?.village?.name}</>}
            </div>
          </Col>
          <Col xs={4}>
            <div className="d-flex align-items-center justify-content-end">
              {head_menu.map((item, key)=>{
                return (
                  <div key={key} className="header-items ms-2" onClick={() => handleClick(item.path)}>
                     {item.icon}
                     {item.path === '/notification' ?
                        <div className="notify"></div> : ''  
                     }
                  </div>
                )
              })}
            </div>
          </Col>
        </Row>
        <h4 className="mb-3 mt-4 text-light">Mitra</h4>
        <div className="d-flex align-items-center justify-content-between">
            <Form.Control 
               value={keyword} 
               onChange={(e) => {  
                  getList(tabsActive, e.target.value);
               }} 
               placeholder="Cari Mitra" className="search search-promo search-with-icon"/>
            <i className="ph-magnifying-glass search-icon"></i>
        </div>
      </div>

      <Tabs
         activeKey={tabsActive}
         className="px-3 tab-p-0"
         style={{position:"relative"}}
         onSelect={(e) => {getList(e,''), setTabsActive(e)}}
      >
         <Tab eventKey='history' title="Riwayat">
            {mitra.map((item,key)=>{
               return item?.pivot?.verification_status == 'success' ?
                  <ListPartner data={item} key={key} tabs="history" loading={loading}/> : null
            })}
         </Tab>
         {/* <Tab eventKey='2' title="Terdekat">
            <ListPickup data={pickup} updateStatus={updateStatus} status={2}/>
         </Tab> */}
         <Tab eventKey='verified' title="Verifikasi">
            {mitra.map((item,key)=>{
               return(<ListPartner data={item} key={key} tabs="verified" loading={loading}/>)
            })}
         </Tab>
         <Tab eventKey='registered' title="Terdaftar">
            {mitra.map((item,key)=>{
               return item?.pivot?.verification_status == 'success' ?
               <ListPartner data={item} key={key} tabs="registered" loading={loading}/> : null
            })}
         </Tab>
      </Tabs>

   </Layout>
  );
}